import { Component, computed, inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { BadgeModule } from 'primeng/badge';
import { LayoutService } from '@/layout/service/layout.service';
import { RouterModule } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { CommonModule } from '@angular/common';

@Component({
    selector: '[app-profilesidebar]',
    imports: [
        ButtonModule,
        DrawerModule,
        BadgeModule,
        RouterModule,
        CommonModule
    ],
    template: `
        <p-drawer
            [visible]="visible()"
            (onHide)="onDrawerHide()"
            position="right"
            [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'"
            styleClass="layout-profile-sidebar w-full sm:w-25rem"
        >
            <div class="flex flex-col mx-auto md:mx-0">
                <span class="mb-2 font-semibold">Bienvenido/a</span>
                <span
                    *ngIf="authService.currentUser() as user"
                    class="text-surface-500 dark:text-surface-400 font-medium mb-8"
                    >{{ user.nombre }} {{ user.apellido }}</span
                >

                <ul class="list-none m-0 p-0">
                    <li>
                        <a [routerLink]="['/perfil']" (click)="onDrawerHide()"
                            class="cursor-pointer flex mb-4 p-4 items-center border border-surface-200 dark:border-surface-700 rounded hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-150"
                        >
                            <span>
                                <i class="pi pi-user text-xl text-primary"></i>
                            </span>
                            <div class="ml-4">
                                <span class="mb-2 font-semibold">Mi Perfil</span>
                                <p
                                    class="text-surface-500 dark:text-surface-400 m-0"
                                >
                                    Configuración de cuenta
                                </p>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a [routerLink]="['/my-reservations']" (click)="onDrawerHide()"
                            class="cursor-pointer flex mb-4 p-4 items-center border border-surface-200 dark:border-surface-700 rounded hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-150"
                        >
                            <span>
                                <i class="pi pi-calendar text-xl text-primary"></i>
                            </span>
                            <div class="ml-4">
                                <span class="mb-2 font-semibold">Mis Reservas</span>
                                <p
                                    class="text-surface-500 dark:text-surface-400 m-0"
                                >
                                    Historial de reservas
                                </p>
                            </div>
                        </a>
                    </li>
                    <li>
                        <a (click)="onLogout()"
                            class="cursor-pointer flex mb-4 p-4 items-center border border-surface-200 dark:border-surface-700 rounded hover:bg-surface-100 dark:hover:bg-surface-800 transition-colors duration-150"
                        >
                            <span>
                                <i
                                    class="pi pi-power-off text-xl text-primary"
                                ></i>
                            </span>
                            <div class="ml-4">
                                <span class="mb-2 font-semibold">Cerrar Sesión</span>
                                <p
                                    class="text-surface-500 dark:text-surface-400 m-0"
                                >
                                    Salir del sistema
                                </p>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        </p-drawer>
    `,
})
export class AppProfileSidebar {
    public layoutService = inject(LayoutService);
    public authService = inject(AuthService);

    visible = computed(
        () => this.layoutService.layoutState().profileSidebarVisible,
    );

    onDrawerHide() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            profileSidebarVisible: false,
        }));
    }

    onLogout() {
        this.onDrawerHide();
        this.authService.logout();
    }
}
